<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('ANAK_KE')" :class="{'form-group': true, 'has-error': errors.has('anak_ke')}">
        <label class="col-md-3"><span class="required-label">*</span>Anak Ke-</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="anak_ke"
            placeholder="Anak Ke-"
            class="form-control"
            v-model="model.anak_ke"
            v-validate="isExist('ANAK_KE') ? 'required' : ''"
          >
          <span v-show="errors.has('anak_ke')" class="error-label">Isi Anak Ke-</span>
        </div>
      </div>
      <div v-show="isExist('JML_SAUDARA')" :class="{'form-group': true, 'has-error': errors.has('jumlah_saudara')}">
        <label class="col-md-3"><span class="required-label">*</span>Jumlah Saudara</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="anak_ke"
            placeholder="Jumlah Saudara"
            class="form-control"
            v-model="model.jumlah_saudara"
            v-validate="isExist('JML_SAUDARA') ? 'required' : ''"
          >
          <span v-show="errors.has('jumlah_saudara')" class="error-label">Isi Jumlah Saudara</span>
        </div>
      </div>
      <div v-show="isExist('TANGGUNGAN_ORTU')" :class="{'form-group': true, 'has-error': errors.has('tanggungan_orang_tua')}">
        <label class="col-md-3"><span class="required-label">*</span>Tanggungan Orang Tua</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="tanggungan_orang_tua"
            placeholder="Tanggungan Orang Tua"
            class="form-control"
            v-model="model.gaji_ibu"
            v-validate="isExist('TANGGUNGAN_ORTU') ? 'required' : ''"
          >
          <span v-show="errors.has('tanggungan_orang_tua')" class="error-label">Isi Tanggungan Orang Tua</span>
        </div>
      </div>
      <div v-show="isExist('GAJI_IBU')" :class="{'form-group': true, 'has-error': errors.has('gaji_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Gaji Ibu</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="gaji_ibu"
            placeholder="Gaji Ibu"
            class="form-control"
            v-model="model.gaji_ibu"
            v-validate="isExist('GAJI_IBU') ? 'required' : ''"
          >
          <span v-show="errors.has('gaji_ibu')" class="error-label">Isi Gaji Ibu</span>
        </div>
      </div>
      <div v-show="isExist('TAB_IBU')" :class="{'form-group': true, 'has-error': errors.has('tabungan_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Tabungan Ibu</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="tabungan_ibu"
            placeholder="Tabungan Ibu"
            class="form-control"
            v-model="model.tabungan_ibu"
            v-validate="isExist('TAB_IBU') ? 'required' : ''"
          >
          <span v-show="errors.has('tabungan_ibu')" class="error-label">Isi Tabungan Ibu</span>
        </div>
      </div>
      <div v-show="isExist('HUTANG_IBU')" :class="{'form-group': true, 'has-error': errors.has('hutang_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Hutang Ibu</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="hutang_ibu"
            placeholder="Hutang Ibu"
            class="form-control"
            v-model="model.hutang_ibu"
            v-validate="isExist('HUTANG_IBU') ? 'required' : ''"
          >
          <span v-show="errors.has('hutang_ibu')" class="error-label">Isi Hutang Ibu</span>
        </div>
      </div>
      <div v-show="isExist('CIL_HUTANG_IBU')" :class="{'form-group': true, 'has-error': errors.has('cicilan_hutang_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Cicilan Hutang Ibu</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="cicilan_hutang_ibu"
            placeholder="Cicilan Hutang Ibu"
            class="form-control"
            v-model="model.cicilan_hutang_ibu"
            v-validate="isExist('CIL_HUTANG_IBU') ? 'required' : ''"
          >
          <span v-show="errors.has('cicilan_hutang_ibu')" class="error-label">Isi Cicilan Hutang Ibu</span>
        </div>
      </div>
      <div v-show="isExist('PIUTANG_IBU')" :class="{'form-group': true, 'has-error': errors.has('piutang_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Piutang Ibu</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="piutang_ibu"
            placeholder="Piutang Ibu"
            class="form-control"
            v-model="model.piutang_ibu"
            v-validate="isExist('PIUTANG_IBU') ? 'required' : ''"
          >
          <span v-show="errors.has('piutang_ibu')" class="error-label">Isi Piutang Ibu</span>
        </div>
      </div>
      <div v-show="isExist('CIL_PIUTANG_IBU')" :class="{'form-group': true, 'has-error': errors.has('cicilan_piutang_ibu')}">
        <label class="col-md-3"><span class="required-label">*</span>Cicilan Piutang Ibu</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="cicilan_piutang_ibu"
            placeholder="Cicilan Piutang Ibu"
            class="form-control"
            v-model="model.cicilan_piutang_ibu"
            v-validate="isExist('CIL_PIUTANG_IBU') ? 'required' : ''"
          >
          <span v-show="errors.has('cicilan_piutang_ibu')" class="error-label">Isi Cicilan Piutang Ibu</span>
        </div>
      </div>
      <div v-show="isExist('GAJI_BPK')" :class="{'form-group': true, 'has-error': errors.has('gaji_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Gaji Ayah</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="gaji_ayah"
            placeholder="Gaji Ayah"
            class="form-control"
            v-model="model.gaji_ayah"
            v-validate="isExist('GAJI_BPK') ? 'required' : ''"
          >
          <span v-show="errors.has('gaji_ayah')" class="error-label">Isi Gaji Ayah</span>
        </div>
      </div>
      <div v-show="isExist('TAB_BPK')" :class="{'form-group': true, 'has-error': errors.has('tabungan_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Tabungan Ayah</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="tabungan_ayah"
            placeholder="Tabungan Ayah"
            class="form-control"
            v-model="model.gaji_ayah"
            v-validate="isExist('TAB_BPK') ? 'required' : ''"
          >
          <span v-show="errors.has('tabungan_ayah')" class="error-label">Isi Tabungan Ayah</span>
        </div>
      </div>
      <div v-show="isExist('HUTANG_BPK')" :class="{'form-group': true, 'has-error': errors.has('hutang_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Hutang Ayah</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="hutang_ayah"
            placeholder="Hutang Ayah"
            class="form-control"
            v-model="model.hutang_ayah"
            v-validate="isExist('HUTANG_BPK') ? 'required' : ''"
          >
          <span v-show="errors.has('hutang_ayah')" class="error-label">Isi Hutang Ayah</span>
        </div>
      </div>
      <div v-show="isExist('CIL_HUTANG_BPK')" :class="{'form-group': true, 'has-error': errors.has('cicilan_hutang_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Cicilan Hutang Ayah</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="cicilan_hutang_ayah"
            placeholder="Cicilan Hutang Ayah"
            class="form-control"
            v-model="model.cicilan_hutang_ayah"
            v-validate="isExist('CIL_HUTANG_BPK') ? 'required' : ''"
          >
          <span v-show="errors.has('cicilan_hutang_ayah')" class="error-label">Isi Cicilan Hutang Ayah</span>
        </div>
      </div>
      <div v-show="isExist('PIUTANG_BPK')" :class="{'form-group': true, 'has-error': errors.has('piutang_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Piutang Ayah</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="piutang_ayah"
            placeholder="Piutang Ayah"
            class="form-control"
            v-model="model.piutang_ayah"
            v-validate="isExist('PIUTANG_BPK') ? 'required' : ''"
          >
          <span v-show="errors.has('piutang_ayah')" class="error-label">Isi Piutang Ayah</span>
        </div>
      </div>
      <div v-show="isExist('CIL_PIUTANG_BPK')" :class="{'form-group': true, 'has-error': errors.has('cicilan_piutang_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Cicilan Piutang Ayah</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="cicilan_piutang_ayah"
            placeholder="Cicilan Piutang Ayah"
            class="form-control"
            v-model="model.cicilan_piutang_ayah"
            v-validate="isExist('CIL_PIUTANG_BPK') ? 'required' : ''"
          >
          <span v-show="errors.has('cicilan_piutang_ayah')" class="error-label">Isi Cicilan Piutang Ayah</span>
        </div>
      </div>
      <div v-show="isExist('GAJI_WALI')" :class="{'form-group': true, 'has-error': errors.has('gaji_wali')}">
        <label class="col-md-3"><span class="required-label">*</span>Gaji Wali</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="gaji_wali"
            placeholder="Gaji Wali"
            class="form-control"
            v-model="model.gaji_wali"
            v-validate="isExist('GAJI_WALI') ? 'required' : ''"
          >
          <span v-show="errors.has('gaji_wali')" class="error-label">Isi Gaji Wali</span>
        </div>
      </div>
      <div v-show="isExist('TAB_WALI')" :class="{'form-group': true, 'has-error': errors.has('tabungan_wali')}">
        <label class="col-md-3"><span class="required-label">*</span>Tabungan Wali</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="tabungan_wali"
            placeholder="Tabungan Wali"
            class="form-control"
            v-model="model.tabungan_wali"
            v-validate="isExist('TAB_WALI') ? 'required' : ''"
          >
          <span v-show="errors.has('tabungan_wali')" class="error-label">Isi Tabungan Wali</span>
        </div>
      </div>
      <div v-show="isExist('HUTANG_WALI')" :class="{'form-group': true, 'has-error': errors.has('hutang_wali')}">
        <label class="col-md-3"><span class="required-label">*</span>Hutang Wali</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="hutang_wali"
            placeholder="Hutang Wali"
            class="form-control"
            v-model="model.hutang_wali"
            v-validate="isExist('HUTANG_WALI') ? 'required' : ''"
          >
          <span v-show="errors.has('hutang_wali')" class="error-label">Isi Hutang Wali</span>
        </div>
      </div>
      <div v-show="isExist('CIL_HUTANG_WALI')" :class="{'form-group': true, 'has-error': errors.has('cicilan_hutang_wali')}">
        <label class="col-md-3"><span class="required-label">*</span>Cicilan Hutang Wali</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="cicilan_hutang_wali"
            placeholder="Cicilan Hutang Wali"
            class="form-control"
            v-model="model.cicilan_hutang_wali"
            v-validate="isExist('CIL_HUTANG_WALI') ? 'required' : ''"
          >
          <span v-show="errors.has('cicilan_hutang_wali')" class="error-label">Isi Cicilan Hutang Wali</span>
        </div>
      </div>
      <div v-show="isExist('PIUTANG_WALI')" :class="{'form-group': true, 'has-error': errors.has('piutang_wali')}">
        <label class="col-md-3"><span class="required-label">*</span>Piutang Wali</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="piutang_wali"
            placeholder="Piutang Wali"
            class="form-control"
            v-model="model.piutang_wali"
            v-validate="isExist('PIUTANG_WALI') ? 'required' : ''"
          >
          <span v-show="errors.has('piutang_wali')" class="error-label">Isi Piutang Wali</span>
        </div>
      </div>
      <div v-show="isExist('CIL_PIUTANG_WALI')" :class="{'form-group': true, 'has-error': errors.has('cicilan_piutang_wali')}">
        <label class="col-md-3"><span class="required-label">*</span>Cicilan Piutang Wali</label>
        <div class="col-md-6">
          <input
            type="number"
            min="0" max="9999999999" step="1" oninput="validity.valid||(value='');"
            name="cicilan_piutang_wali"
            placeholder="Cicilan Piutang Wali"
            class="form-control"
            v-model="model.cicilan_piutang_wali"
            v-validate="isExist('CIL_PIUTANG_WALI') ? 'required' : ''"
          >
          <span v-show="errors.has('cicilan_piutang_wali')" class="error-label">Isi Cicilan Piutang Wali</span>
        </div>
      </div>
      <div v-show="isExist('KK')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Kartu Keluarga</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointKartuKeluarga"
            :headers="header"
            name="kartu_keluarga"
            :data="dataUpload"
            :on-error="handleKartuKeluargaError"
            :on-success="handleKartuKeluargaSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.kartu_keluarga"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png tidak boleh lebih dari 1 MB</strong></div>
            <div class="alert alert-error" slot="tip" style="text-align: left">
            </div>
          </el-upload>
          <div v-if="kartuKeluargaUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="kartuKeluargaUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
      <div v-show="isExist('KRT_PENGHASILAN_BPK')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Kartu Penghasilan Ayah</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointKartuPenghasilanAyah"
            :headers="header"
            name="surat_keterangan_penghasilan_ayah"
            :data="dataUpload"
            :on-error="handleKartuPenghasilanAyahError"
            :on-success="handleKartuPenghasilanAyahSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.kartu_penghasilan_ayah"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png tidak boleh lebih dari 1 MB</strong></div>
            <div class="alert alert-error" slot="tip" style="text-align: left">
            </div>
          </el-upload>
          <div v-if="kartuPenghasilanAyahUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="kartuPenghasilanAyahUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
      <div v-show="isExist('KRT_PENGHASILAN_IBU')" class="form-group">
        <label class="col-md-3"><span class="required-label">*</span>Kartu Penghasilan Ibu</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointKartuPenghasilanIbu"
            :headers="header"
            name="surat_keterangan_penghasilan_ibu"
            :data="dataUpload"
            :on-error="handleKartuPenghasilanIbuError"
            :on-success="handleKartuPenghasilanIbuSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.kartu_penghasilan_ibu"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png tidak boleh lebih dari 1 MB</strong></div>
            <div class="alert alert-error" slot="tip" style="text-align: left">
            </div>
          </el-upload>
          <div v-if="kartuPenghasilanIbuUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="kartuPenghasilanIbuUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
      <div v-show="isExist('KRT_PENGHASILAN_WALI')" class="form-group">
        <label class="col-md-3">Kartu Penghasilan Wali</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointKartuPenghasilanWali"
            :headers="header"
            name="surat_keterangan_penghasilan_wali"
            :data="dataUpload"
            :on-error="handleKartuPenghasilanWaliError"
            :on-success="handleKartuPenghasilanWaliSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.kartu_penghasilan_wali"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png tidak boleh lebih dari 1 MB</strong></div>
            <div class="alert alert-error" slot="tip" style="text-align: left">
            </div>
          </el-upload>
          <div v-if="kartuPenghasilanWaliUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="kartuPenghasilanWaliUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
      <div v-show="isExist('KRT_MISKIN')" class="form-group">
        <label class="col-md-3">Kartu Miskin</label>
        <div class="col-md-6">
          <el-upload
            class="upload-demo"
            :action="docEndPointKartuMiskin"
            :headers="header"
            name="kartu_miskin"
            :data="dataUpload"
            :on-error="handleKartuMiskinError"
            :on-success="handleKartuMiskinSuccess"
            :limit="1"
            :on-exceed="handleExceed"
            :before-upload="beforeDocsUpload"
            :file-list="file.kartu_miskin"
            drag>
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">Drop file here or <em>click to upload</em></div>
            <div class="el-upload__tip" slot="tip"><strong>Format pdf/jpg/png tidak boleh lebih dari 1 MB</strong></div>
            <div class="alert alert-error" slot="tip" style="text-align: left">
            </div>
          </el-upload>
          <div v-if="kartuMiskinUrl" style="margin-top: 20px" class="alert alert-success">File berhasil disimpan. <a :href="kartuMiskinUrl" target="_blank">Cek Dokumen</a></div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import api from '@/api'
import { baseURL } from '@/api/data'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  data () {
    return {
      init: false,
      loading: true,
      sending: false,
      kartuKeluargaUrl: '',
      kartuPenghasilanAyahUrl: '',
      kartuPenghasilanIbuUrl: '',
      kartuMiskinUrl: '',
      // kartu_penghasilan_ayah_url: '',
      // kartu_penghasilan_wali_url: '',
      // kartu_penghasilan_ibu_url: '',
      // kartu_miskin_url: '',
      model: {
        anak_ke: '',
        jumlah_saudara: '',
        tanggungan_orang_tua: '',
        gaji_ibu: '',
        tabungan_ibu: '',
        hutang_ibu: '',
        cicilan_hutang_ibu: '',
        piutang_ibu: '',
        cicilan_piutang_ibu: '',
        gaji_ayah: '',
        tabungan_ayah: '',
        hutang_ayah: '',
        cicilan_hutang_ayah: '',
        piutang_ayah: '',
        cicilan_piutang_ayah: '',
        gaji_wali: '',
        tabungan_wali: '',
        hutang_wali: '',
        cicilan_hutang_wali: '',
        piutang_wali: '',
        cicilan_piutang_wali: '',
        status_perkawinan: '',
        nama_pasangan: '',
        keterangan: ''
      },
      savedModel: null,
      file: {
        kartu_keluarga: [],
        kartu_penghasilan_ayah: [],
        kartu_penghasilan_ibu: [],
        kartu_penghasilan_wali: [],
        kartu_miskin: []
      }
    }
  },
  updated () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been re-rendered
      var elements = document.getElementsByClassName('el-upload__input')
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0])
      }
    })
  },
  components: {
    'pulse-loader': PulseLoader
  },
  computed: {
    baseUrl () {
      return baseURL
    },
    header () {
      let token = localStorage.getItem('client-admisi-token')
      let headerAPI = {
        'Authorization': `Bearer ${token}`
      }
      return headerAPI
    },
    dataUpload () {
      let data = {nomor_pendaftar: this.nomorPendaftar}
      return data
    },
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    docEndPointKartuKeluarga () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_keluarga/kartu_keluarga'
      } else {
        return 'test'
      }
    },
    docEndPointKartuPenghasilanAyah () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_keluarga/sk_penghasilan_ayah'
      } else {
        return 'test'
      }
    },
    docEndPointKartuPenghasilanIbu () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_keluarga/sk_penghasilan_ibu'
      } else {
        return 'test'
      }
    },
    docEndPointKartuPenghasilanWali () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_keluarga/sk_penghasilan_wali'
      } else {
        return 'test'
      }
    },
    docEndPointKartuMiskin () {
      if (process.env.NODE_ENV !== 'test') {
        return baseURL + 'v2/data_keluarga/kartu_miskin'
      } else {
        return 'test'
      }
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(3).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              let kartuKeluargaUploaded = this.file.kartu_keluarga.length > 0
              let kartuPenghasilanAyahUploaded = this.file.kartu_penghasilan_ayah.length > 0
              let kartuPenghasilanIbuUploaded = this.file.kartu_penghasilan_ibu.length > 0
              !kartuKeluargaUploaded && this.isExist('KK') ? reject({message: 'belum ada file kartu keluarga'}) : false
              !kartuPenghasilanAyahUploaded && this.isExist('KRT_PENGHASILAN_BPK') ? reject({message: 'belum ada file surat keterangan penghasilan ayah'}) : false
              !kartuPenghasilanIbuUploaded && this.isExist('KRT_PENGHASILAN_IBU') ? reject({message: 'belum ada file surat keterangan penghasilan ibu'}) : false
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 3)
    },
    initData () {
      if (!this.init) {
        this.getData()
        this.getFileKartuKeluarga()
        this.getFileKartuPenghasilanAyah()
        this.getFileKartuPenghasilanIbu()
        this.getFileKartuPenghasilanWali()
        this.getFileKartuMiskin()
        this.init = true
      }
    },
    handleKartuKeluargaError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.kartu_keluarga = [{name: 'kartu_keluarga' + this.nomorPendaftar + '.pdf'}]
        this.kartuKeluargaUrl = 'Test'
      }
    },
    handleKartuPenghasilanAyahError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.kartu_penghasilan_ayah = [{name: 'kartu_penghasilan_ayah' + this.nomorPendaftar + '.pdf'}]
        this.kartuPenghasilanAyahUrl = 'Test'
      }
    },
    handleKartuPenghasilanIbuError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.kartu_penghasilan_ibu = [{name: 'kartu_penghasilan_ibu' + this.nomorPendaftar + '.pdf'}]
        this.kartuPenghasilanIbuUrl = 'Test'
      }
    },
    handleKartuPenghasilanWaliError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.kartu_penghasilan_wali = [{name: 'kartu_penghasilan_wali' + this.nomorPendaftar + '.pdf'}]
        this.kartuPenghasilanWaliUrl = 'Test'
      }
    },
    handleKartuMiskinError (err, file, fileList) {
      if (process.env.NODE_ENV !== 'test') {
        let res = JSON.parse(err.message)
        alert(`upload error, ${res.message}`)
      } else {
        this.file.kartu_miskin = [{name: 'kartu_miskin' + this.nomorPendaftar + '.pdf'}]
        this.kartuMiskinUrl = 'Test'
      }
    },
    handleKartuKeluargaSuccess (res, file) {
      this.getFileKartuKeluarga()
      alert('upload sukses')
    },
    handleKartuPenghasilanAyahSuccess (res, file) {
      this.getFileKartuPenghasilanAyah()
      alert('upload sukses')
    },
    handleKartuPenghasilanIbuSuccess (res, file) {
      this.getFileKartuPenghasilanIbu()
      alert('upload sukses')
    },
    handleKartuPenghasilanWaliSuccess (res, file) {
      this.getFileKartuPenghasilanWali()
      alert('upload sukses')
    },
    handleKartuMiskinSuccess (res, file) {
      this.getFileKartuMiskin()
      alert('upload sukses')
    },
    handleExceed () {
      alert('maksimal 1 file')
    },
    beforeDocsUpload (file) {
      const isMIME = file.type === 'application/pdf' || file.type === 'image/png' || file.type === 'image/jpeg'
      const isLt2M = file.size < 1000000
      !isMIME ? alert('Dokumen berformat pdf/jpg/png') : false
      !isLt2M ? alert('Dokumen tidak boleh lebih dari 1 MB') : false
      return isMIME && isLt2M
    },
    getData () {
      this.loading = true
      api.get('/v1/data_keluarga/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            let data = responseData.data
            this.model = data
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    getFileKartuKeluarga () {
      api.get('v2/data_keluarga/kartu_keluarga/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.kartu_keluarga = [{name: `kartu_keluarga_${this.nomorPendaftar}.${responseData.ext}`}]
            this.kartuKeluargaUrl = responseData.url
          }
        })
    },
    getFileKartuPenghasilanAyah () {
      api.get('v2/data_keluarga/sk_penghasilan_ayah/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.kartu_penghasilan_ayah = [{name: `kartu_penghasilan_ayah${this.nomorPendaftar}.${responseData.ext}`}]
            this.kartuPenghasilanAyahUrl = responseData.url
          }
        })
    },
    getFileKartuPenghasilanIbu () {
      api.get('v2/data_keluarga/sk_penghasilan_ibu/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.kartu_penghasilan_ibu = [{name: `kartu_penghasilan_ibu${this.nomorPendaftar}.${responseData.ext}`}]
            this.kartuPenghasilanIbuUrl = responseData.url
          }
        })
    },
    getFileKartuPenghasilanWali () {
      api.get('v2/data_keluarga/sk_penghasilan_wali/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.kartu_penghasilan_wali = [{name: `kartu_penghasilan_wali${this.nomorPendaftar}.${responseData.ext}`}]
            this.kartuPenghasilanWaliUrl = responseData.url
          }
        })
    },
    getFileKartuMiskin () {
      api.get('v2/data_keluarga/kartu_miskin/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.file.kartu_miskin = [{name: `kartu_miskin${this.nomorPendaftar}.${responseData.ext}`}]
            this.kartuMiskinUrl = responseData.url
          }
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/data_keluarga', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataKeluarga.vue